import axios from "axios";
import {computed, unref} from "vue";
import {keepPreviousData, useMutation, useQuery, useQueryClient} from "@tanstack/vue-query";

export const usePyCrawlFormatters = () => {
    const formatRate = (rate) => {
        if (rate === null || rate === undefined) {
            return '—';
        }
        return `${(rate * 100).toFixed(1)}%`;
    };

    const formatDuration = (seconds) => {
        if (seconds === null || seconds === undefined) {
            return '—';
        }
        const mins = Math.floor(seconds / 60);
        const secs = Math.round(seconds % 60);
        if (mins === 0) {
            return `${secs}s`;
        }
        return `${mins}m ${secs}s`;
    };

    const formatCount = (count) => {
        if (count === null || count === undefined) {
            return '—';
        }
        return count.toLocaleString();
    };

    const formatDateTime = (dateTime) => {
        if (!dateTime) {
            return '—';
        }
        return new Date(dateTime).toLocaleString();
    };

    return {formatRate, formatDuration, formatCount, formatDateTime};
};

export const usePyCrawlAnalytics = () => {
    return useQuery({
        queryKey: ['pycrawl-analytics'],
        queryFn: async () => {
            const response = await axios.get('/ajax/v2/admin/pycrawl/analytics');
            return response.data;
        },
        refetchInterval: 20000,
    });
};
